import React from "react";
import { Link } from "gatsby"

const isExternalLink = (url) => {
	return /^(f|ht)tps?:\/\//i.test(url);
}
function MyLink({ href, children }) {
	const isExternal = isExternalLink(href);

	if (isExternal) {
		return (
			<a href={href} rel="noopener noreferrer" target="_blank">
				{children}
			</a>
		);
	}

	return <Link to={href}>{children}</Link>;
}

export default MyLink